import { UserBehaviorRisksSideMenuWebComponent } from './component/UserBehaviorRisksSideMenuWebComponent';

export { UserBehaviorRisksSideMenuWebComponent };
